export default __webpack_public_path__ + "static/media/logo.754e685f.png";